import { render, staticRenderFns } from "./RelatorioCargaDescargaListFiltroModalItemInputFornecedor.vue?vue&type=template&id=1625778e"
import script from "./RelatorioCargaDescargaListFiltroModalItemInputFornecedor.vue?vue&type=script&lang=js"
export * from "./RelatorioCargaDescargaListFiltroModalItemInputFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports